<template>
    <b-container id="topbar_wrapper" class="w-100">
       <b-img :src="getCompanyImageUrl()"></b-img>
       <b-link href="http://comprovei.com" target="blank"><b-img src="@/assets/logo_comprovei_black.png" class="float-right"></b-img></b-link>
    </b-container>
</template>

<script>
export default {
    name: 'TopBar',
    props: ['data'],
    methods:{
        getCompanyImageUrl() {
            return this.data.documentInfo.company_picture
        }
    }
}
</script>

<style>
#topbar_wrapper{
    background: #ffffff;
    padding: 10px 10px 10px 30px;
    border-right: 1px solid #c5c5c5;
    border-left: 1px solid #c5c5c5;
}

#topbar_wrapper img{
    width: auto;
    max-height: 40px;
}
</style>
